/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Zeeshan Nawaz",
  title: "Hi all,   ",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with JavaScript / Reactjs / Nextjs / Nodejs /Tailwind CSS and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1FUoXE2MdnUQS9iaYJH91idbFQDFDO9rF/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/zeeshanmnawaz786",
  linkedin: "https://www.linkedin.com/in/zmnawaz/",
  gmail: "zeeshanm.nawaz786@gmail.com",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your website"
    ),
    emoji(
      "⚡ As a full stack developer with MERN skills, I have expertise in developing Progressive Web Applications (PWA) using both normal and SPA stacks."
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/ Facebook API and some others"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "yarn",
      fontAwesomeClassname: "fab fa-yarn"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "mongoDB",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Benazir Bhutto Shaheed University",
      logo: require("./assets/images/bbsulLogo.png"),
      subHeader: "",
      duration: "",
      desc: "",
      descBullets: [
        "Education: Bachelor's Degree of Information Technology",
        "University: Benazir Bhutto Shaheed University Lyari Karachi Sindh",
        "Year: 2020",
        "Skills acquired: Strong foundation in computer science, programming, software engineering, and information technology",
        "Career prospects: Various opportunities to pursue a successful career in the IT industry"
      ]
    },
    {
      schoolName: "Govt. Degree Boys & Girls College SRE-III, Majeed",
      logo: require("./assets/images/collegeLogo.jpg"),
      subHeader: "",
      duration: "",
      desc: "",
      descBullets: [
        "He completed the Pre-Engineering program at Govt. Degree Boys & Girls College SRE-III, Majeed, Karachi in 2020",
        "The program provided him with a strong foundation in math and science principles essential for pursuing a career in engineering.",
        "He has gained the knowledge and skills required to embark on a career in the engineering field."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  //   display: true, //Set it to true to show workExperiences Section
  //   experience: [
  //     {
  //       role: "Full Stack Developer",
  //       company: "BawdicSoft",
  //       companylogo: require("./assets/images/facebookLogo.png"),
  //       date: "June 2018 – Present",
  //       desc: "As a Full Stack Developer at BawdicSoft, I gained one year of valuable experience in developing and maintaining web applications from end-to-end. I worked with various technologies, including HTML/CSS, JavaScript, React, Node.js, and SQL, to deliver high-quality solutions that meet client needs. Throughout my tenure, I collaborated with cross-functional teams to implement new features, debug and troubleshoot issues, and continuously improve application performance. I also gained a deep understanding of software development best practices, agile methodologies, and the importance of teamwork in delivering successful projects.",
  //       descBullets: []
  //     }
  //     // {
  //     //   role: "Front-End Developer",
  //     //   company: "Quora",
  //     //   companylogo: require("./assets/images/quoraLogo.png"),
  //     //   date: "May 2017 – May 2018",
  //     //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  //     // },
  //     // {
  //     //   role: "Software Engineer Intern",
  //     //   company: "Airbnb",
  //     //   companylogo: require("./assets/images/airbnbLogo.png"),
  //     //   date: "Jan 2015 – Sep 2015",
  //     //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
  //     // }
  //   ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME PROJECTS THAT I HAVE CREATED",
  projects: [
    // truckBo
    {
      image: require("./assets/images/truckImage.png"),
      projectName: "Truckbo",
      // projectDesc:
      // " I have designed and developed various elements of the Windows 8.1 UI, including the live tiles, Start screen, and overall layout. Through my portfolio, visitors can see examples of my work on Windows 8.1.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://transport-1.vercel.app/"
        }
      ]
    },
    // timetable
    {
      image: require("./assets/images/smartTimTable.png"),
      projectName: "Smart Time Table",
      // projectDesc:
      // "Smart Time Table is a user-friendly system for teachers and students to access daily schedules. The admin panel allows authorized personnel to update the schedule and teacher information to ensure accuracy.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://smart-timetable.vercel.app//"
        }
      ]
    },
    // window 8.1
    {
      image: require("./assets/images/window8.1.png"),
      projectName: "Window 8.1",
      // projectDesc:
      // " I have designed and developed various elements of the Windows 8.1 UI, including the live tiles, Start screen, and overall layout. Through my portfolio, visitors can see examples of my work on Windows 8.1.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://window-8.netlify.app/"
        }
      ]
    },
    //  omega landing page
    {
      image: require("./assets/images/omegaLogo.png"),
      projectName: "Omega LandingPage",
      // projectDesc:
      // "The Omega LandingPage is a sleek and engaging standalone web page designed to capture visitors' attention and encourage them to take action, featuring a striking Omega logo and optimized for conversion.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://landingpagetailwind.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    // digital clock
    {
      image: require("./assets/images/digital-clock.png"),
      projectName: "Digital Clock",
      // projectDesc:
      // "A login page is a web page that allows users to securely access a system or application by entering their username and password. It typically includes a form with input fields for credentials and a submit button.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://digital-clock-5.netlify.app/"
        }
      ]
    },
    // stop watch
    {
      image: require("./assets/images/stopWatch.png"),
      projectName: "Stop watch",
      // projectDesc:
      // "A portfolio UI is a user interface that displays a collection of work in a visually appealing way, allowing users to showcase their skills and achievements to potential clients, employers, or colleagues.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://stop-watch-6.netlify.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  // title: emoji("Achievements And Certifications 🏆 "),
  // subtitle:
  //   "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",
  // achievementsCards: [
  //   {
  //     title: "Google Code-In Finalist",
  //     subtitle:
  //       "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
  //     image: require("./assets/images/codeInLogo.webp"),
  //     imageAlt: "Google Code-In Logo",
  //     footerLink: [
  //       {
  //         name: "Certification",
  //         url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
  //       },
  //       {
  //         name: "Award Letter",
  //         url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
  //       },
  //       {
  //         name: "Google Code-in Blog",
  //         url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
  //       }
  //     ]
  //   },
  //   {
  //     title: "Google Assistant Action",
  //     subtitle:
  //       "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
  //     image: require("./assets/images/googleAssistantLogo.webp"),
  //     imageAlt: "Google Assistant Action Logo",
  //     footerLink: [
  //       {
  //         name: "View Google Assistant Action",
  //         url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
  //       }
  //     ]
  //   },
  //   {
  //     title: "PWA Web App Developer",
  //     subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
  //     image: require("./assets/images/pwaLogo.webp"),
  //     imageAlt: "PWA Logo",
  //     footerLink: [
  //       {name: "Certification", url: ""},
  //       {
  //         name: "Final Project",
  //         url: "https://pakistan-olx-1.firebaseapp.com/"
  //       }
  //     ]
  //   }
  // ],
  // display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  // title: "Blogs",
  // subtitle:
  //   "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  // displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  // blogs: [
  //   {
  //     url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
  //     title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
  //     description:
  //       "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
  //   },
  //   {
  //     url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
  //     title: "Why REACT is The Best?",
  //     description:
  //       "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
  //   }
  // ],
  // display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  // title: "TALKS",
  // subtitle: emoji(
  //   "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  // ),
  // talks: [
  //   {
  //     title: "Build Actions For Google Assistant",
  //     subtitle: "Codelab at GDG DevFest Karachi 2019",
  //     slides_url: "https://bit.ly/saadpasta-slides",
  //     event_url: "https://www.facebook.com/events/2339906106275053/"
  //   }
  // ],
  // display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  // title: emoji("Podcast 🎙️"),
  // subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  // // Please Provide with Your Podcast embeded Link
  // podcast: [
  //   "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  // ],
  // display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3458895645",
  email_address: "zeeshanm.nawaz786@gmail.com"
};

// Twitter Section

const twitterDetails = {
  // userName: "twitter", //Replace "twitter" with your twitter username without @
  // display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
